import React from 'react';

const StoryManagerIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Folder body */}
    <path
      d="M2 5.5C2 4.7 2.7 4 3.5 4H7L8.5 6H14.5C15.3 6 16 6.7 16 7.5V13.5C16 14.3 15.3 15 14.5 15H3.5C2.7 15 2 14.3 2 13.5V5.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default StoryManagerIcon;
